module.exports = __webpack_public_path__ + "img/noDataFoundGreen.f048efc8.svg";